module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-google-tagmanager-delayed/gatsby-browser.js'),
      options: {"plugins":[],"id":"GTM-5Q29X9","includeInDevelopment":false,"defaultDataLayer":{"type":"object","value":{"platform":"gatsby"}}},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"display":"minimal-ui","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"157b1bb8e0a76c60e1b434c8ddfe5540"},
    },{
      plugin: require('../node_modules/gatsby-plugin-datadog/gatsby-browser.js'),
      options: {"plugins":[],"site":"datadoghq.com","service":"unicef-home","env":"prod","version":"1.0.0","sampleRate":80,"sessionSampleRate":80,"enabled":true,"rum":{"applicationId":"9ef76758-1574-4666-bce9-d2b9330090fc","clientToken":"pubddff452def7dff7f39900213ca3bfc12","sessionReplaySampleRate":100,"allowedTracingUrls":[{},{}]},"logs":{"clientToken":"pubddff452def7dff7f39900213ca3bfc12"}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
